import { render, staticRenderFns } from "./spWorkChoose.vue?vue&type=template&id=6f90eae0&scoped=true"
import script from "./spWorkChoose.vue?vue&type=script&lang=js"
export * from "./spWorkChoose.vue?vue&type=script&lang=js"
import style0 from "./spWorkChoose.vue?vue&type=style&index=0&id=6f90eae0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f90eae0",
  null
  
)

export default component.exports